import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getParasha } from "@/lib/parashiot.functions";
import { TeachingCard } from "@/components/teaching-card";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/_authenticated/parashiot/$slug")({
  component: ParashaDetail,
});

function ParashaDetail() {
  const { slug } = useParams({ from: "/_authenticated/parashiot/$slug" });
  const fn = useServerFn(getParasha);
  const { data, isLoading, error } = useQuery({
    queryKey: ["parasha", slug],
    queryFn: () => fn({ data: { slug } }),
  });

  if (isLoading) return <div className="h-64 animate-pulse rounded-xl bg-secondary" />;
  if (error || !data) return <p className="text-destructive">Parashá não encontrada.</p>;

  const { parasha, teachings } = data;

  return (
    <div className="space-y-8">
      <Link
        to="/parashiot"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary"
      >
        <ArrowLeft className="h-4 w-4" /> Todas as Parashiot
      </Link>

      <header className="rounded-2xl border border-border bg-card p-8">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="mb-2 text-sm font-medium uppercase tracking-wide text-gold">
              {parasha.number}ª Porção da Torá · {parasha.book}
            </p>
            <h1 className="font-serif text-4xl font-semibold text-primary">
              {parasha.name_translit}
            </h1>
            <p className="mt-1 text-xl text-muted-foreground">{parasha.name_pt}</p>
            {parasha.chapters && (
              <p className="mt-2 text-sm text-muted-foreground">{parasha.chapters}</p>
            )}
          </div>
          <div className="font-serif text-5xl text-primary/70" dir="rtl">
            {parasha.name_he}
          </div>
        </div>
      </header>

      <section>
        <h2 className="mb-6 font-serif text-2xl font-semibold text-primary">
          Ensinos desta Parashá ({teachings.length})
        </h2>
        {teachings.length === 0 ? (
          <div className="rounded-xl border border-dashed border-border p-12 text-center text-muted-foreground">
            Ainda não há ensinos cadastrados para esta Parashá.
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {teachings.map((t: any) => (
              <TeachingCard key={t.id} teaching={t} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
